import Home from "../pages/Home";
import Login from "../pages/auth/Login";
import Channels from "../pages/channels/Channels"
import Approval from "../pages/AudioBook/Approval"
import AudioBookList from "../pages/AudioBook/AudioBookList"
import Publisher from "../pages/publisher/Publisher"
import Payment from "../pages/payment/Payment"
import PageNotFound from "../pages/PageNotFound"
import PublisherChannel from "../pages/publisher/PublisherChannel"
import PublisherAudiobook from "../pages/publisher/PublisherAudiobook"
import guard from "../guard"
import PaymentDetails from "../pages/payment/PaymentDetails"
import ChannelDetails from "../pages/channels/ChannelDetails"
import Pending from "../pages/channels/Pending"
import Reject from "../pages/channels/Reject"
import Category from "../pages/category/Category"
import Profile from "../pages/user/Profile"

import Master_analytics from "../pages/audiobookAnalytics/Master_analytics"

import AudioBookTopUser from "../pages/top user/AudioBookTopUser"
import EpisodeTopUser from "../pages/top user/EpisodeTopUser"
import MasterTopUser from "../pages/top user/MasterTopUser"
import PlayCountMaster from "../pages/playCounts/PlayCountMaster"
import Refund from "../pages/refund/template/Refund";
import SubscribeUserList from "@/pages/subscribeUserList/template/SubscribeUserList";
import CastCrew from "@/pages/CastCrew/template/CastCrew";
import QuizParticipants from "@/pages/quiz/template/QuizParticipants";
import Author from "@/pages/author/template/Author";
import WinnerList from "@/pages/winnerList/template/WinnerList";
import Notification from "@/pages/notifications/template/Notification";
import QuizQuestion from "@/pages/quiz/template/QuizQuestion";
import LatestTransactions from "@/pages/latest-transactions/template/LatestTransactions";
import First_subscribed_try_then_failed from "@/pages/subscribeUserList/template/First_subscribed_try_then_failed";
import Was_subscribed_then_canceled from "@/pages/subscribeUserList/template/Was_subscribed_then_canceled";
import ReviewList from "@/pages/review/template/ReviewList";
import DailyPlaylist from "@/pages/dailyAudiobookPlaylist/template/DailyPlaylist";
import KabbikBlog from "../pages/kabbikBlog/template/KabbikBlog";
import Promo from "../pages/promoCode/template/Promo";
import BookRequestList from "../pages/bookRequest/template/BookRequestList";
import UpcomingBookList from "../pages/upcomingList/template/UpcomingBookList";
import PublisherManagement from "../pages/publisherManagement/template/PublisherManagement";
import RecordingList from "../pages/bookRecordingManagement/template/RecordingList";
// const restrictRoutes = (to, from, next)=>{
//     if(localStorage.getItem("token")){
//         next()
//     }else{
//         next(false)
//     }

// }
const routes = [
    {
        path: "/",
        meta: { title: 'Home' },
        redirect: {name: "Dashboard"},
    },
    {
        path: "/home",
        name: "Dashboard",
        component: Home,
        meta: { title: 'Home' },
        beforeEnter: guard

    },

    {
        path: "/master-top-user",
        name: "MasterTopUser",
        component: MasterTopUser,
        beforeEnter: guard
    },
    {
        path: "/audiobook-top-user",
        name: "AudioBookTopUser",
        component: AudioBookTopUser,
        beforeEnter: guard
    },
    {
        path: "/episode-top-user",
        name: "EpisodeTopUser",
        component: EpisodeTopUser,
        beforeEnter: guard
    },
    {
        path: "/channels",
        name: "Channels",
        component: Channels,
        beforeEnter: guard
    },
    {
        path: "/play-count-master",
        name: "PlayCountMaster",
        component: PlayCountMaster,
        beforeEnter: guard
    },
    {
        path: "/audiobookAnalytics",
        name: "Master_analytics",
        component: Master_analytics,
        beforeEnter: guard
    },
    {
        path: "/approval",
        component: Approval,
        meta: { title: 'AudioBook Approval' },
        beforeEnter: guard
    },
    {
        path: "/audiobooklist",
        component: AudioBookList,
    },
    {
        path: "/daily-audiobook-playlist",
        component: DailyPlaylist,
        meta: { title: 'DailyPlaylist' },
        beforeEnter: guard
    },
    {
        path: "/creators",
        component: Publisher,
        meta: { title: 'Publishers' },
        beforeEnter: guard
    },
    {
        path: "/publisher-management",
        component: PublisherManagement,
        meta: { title: 'publisher-management' },
        beforeEnter: guard
    },
    {
        path: "/audiobook/:id",
        component: PublisherAudiobook,
        name:"PublisherAudiobook",
        meta: { title: 'audiobook' },
        beforeEnter: guard
    },
    {
        path: "/channel/:id",
        component: PublisherChannel,
        meta: { title: 'channel' },
        beforeEnter: guard
    },
    {
        path: "/refund",
        component: Refund,
        meta: { title: 'refund' },
        beforeEnter: guard
    },
    {
        path: "/subscribe-user-list",
        component: SubscribeUserList,
        meta: { title: 'SubscribeUserList' },
        beforeEnter: guard
    },
    {
        path: "/first-subscribed-try-then-failed",
        component: First_subscribed_try_then_failed,
        meta: { title: 'First_subscribed_try_then_failed' },
        beforeEnter: guard
    },
    {
        path: "/was-subscribed-then-canceled",
        component: Was_subscribed_then_canceled,
        meta: { title: 'Was_subscribed_then_canceled' },
        beforeEnter: guard
    },
    {
        path: "/review-list",
        component: ReviewList,
        meta: { title: 'ReviewList' },
        beforeEnter: guard
    },
    {
        path: "/latest-transactions-list",
        component: LatestTransactions,
        meta: { title: 'Latest Transactions' },
        beforeEnter: guard
    },
    //cast and crew
    {
        path: "/cast-crew-list",
        component: CastCrew,
        meta: { title: 'cast-crew-list' },
        beforeEnter: guard
    },
    {
        path: "/recording",
        component: RecordingList,
        meta: { title: 'recording list' },
        beforeEnter: guard
    },
    //author
    {
        path: "/author-list",
        component: Author,
        meta: { title: 'author-list' },
        beforeEnter: guard
    },
    //quiz
    {
        path: "/quiz-participants-list",
        component: QuizParticipants,
        meta: { title: 'quiz-participants-list' },
        beforeEnter: guard
    },
    {
        path: "/quiz-question",
        component: QuizQuestion,
        meta: { title: 'quiz-question' },
        beforeEnter: guard
    },
    {
        path: "/quiz-winner-list",
        component: WinnerList,
        meta: { title: 'quiz-winner-list' },
        beforeEnter: guard
    },
    {
        path: "/notification",
        component: Notification,
        meta: { title: 'notification' },
        beforeEnter: guard
    },
    {
        path: "/blog-list",
        component: KabbikBlog,
        name: "KabbikBlog",
        meta: { title: 'Kabbik-Blog' },
        beforeEnter: guard
    },
    {
        path: "/promo",
        component: Promo,
        name: "Promo",
        meta: { title: 'promo' },
        beforeEnter: guard
    },
    {
        path: "/book-request-list",
        component: BookRequestList,
        name: "BookRequestList",
        meta: { title: 'book-request-list' },
        beforeEnter: guard
    },
    {
        path: "/upcoming-book-list",
        component: UpcomingBookList,
        name: "UpcomingBookList",
        meta: { title: 'upcoming-book-list' },
        beforeEnter: guard
    },

    {
        path: "/login",
        component: Login,
        meta: { title: 'Login' }
    },
    {
        path: '/404',
        name: '404',
        component: PageNotFound
    },
    {
        path: "/payment",
        name: "Payment",
        component: Payment,
        meta: { title: 'Payment' },

    },
    {
        path: "/details/:vp",
        name: "PaymentDetails",
        component: PaymentDetails

    },
    {
        path: "/channel-details/:id",
        name: "ChannelDetails",
        component: ChannelDetails

    },
    {
        path: "/category",
        name: "Category",
        component: Category
    },
    {
        path: "/profile",
        name: "Profile",
        component: Profile
    },
    {
        path: "/admin-pendings/:id",
        name: "Pending",
        component: Pending
    },
    {
        path: "/admin-reject/:id",
        name: "Reject",
        component: Reject
    },

    {
        path: '*', beforeEnter: (to, from, next) => {
            const token = localStorage.getItem('token');
            if (token) {
                next('/404');
            } else {
                next('/login');
            }
        }
    },
];

export default routes;
